<div [class.modal-full-page-body]="isSomeSectionExpanded">
  <div class="title flex h-7 items-center justify-between">
    <div class="text-[1.125rem] leading-7 font-bold text-font-primary">Edit Business Account</div>
    <button
      class="font-normal text-primary hover:text-secondary py-1 px-2 text-sm text-right"
      (click)="toggleAll(!this.isSomeSectionExpanded)"
    >
      {{ isSomeSectionExpanded ? 'Collapse All' : 'Expand All' }}
    </button>
  </div>

  <div class="separator"></div>

  <div class="form expandable-form" [class.form-with-error]="submitError">
    <app-expandable-form-section
      title="Profile Detail"
      titleIconName="briefcase"
      [isExpanded]="sectionsExpanded.profileDetail"
      (toggled)="toggleSection('profileDetail')"
    >
      <div class="details-page-edit-form">
        <form [formGroup]="editForm">
          <rkt-form [form]="editForm" [fields]="formFields" [model]="formModel" (modelChange)="modelChange($event)"></rkt-form>
        </form>
      </div>
    </app-expandable-form-section>

    <div class="separator"></div>

    <app-expandable-form-section
      title="Business Contact Person"
      titleIconName="profile"
      [isExpanded]="sectionsExpanded.primaryContactPerson"
      (toggled)="toggleSection('primaryContactPerson')"
    >
      <div class="details-page-edit-form">
        <form [formGroup]="editForm">
          <rkt-form [form]="editForm" [fields]="contactPersonFormFields" [model]="formModel"></rkt-form>
        </form>
      </div>
    </app-expandable-form-section>

    <div class="separator"></div>

    <app-expandable-form-section
      id="physicalAddresses"
      title="Physical Address"
      titleIconName="location"
      [isExpanded]="sectionsExpanded.physicalAddresses"
      (toggled)="toggleSection('physicalAddresses')"
    >
      <app-address-edit
        type="PHYSICAL"
        [isRequired]="true"
        [addresses]="businessAccountAddresses.physicalAddresses"
        (changed)="setAddresses($event, 'physicalAddresses')"
        (isFormInvalid)="addressFormValidity['PHYSICAL'] = $event"
      />
    </app-expandable-form-section>

    <div class="separator"></div>

    <app-expandable-form-section
      title="Mailing Address"
      titleIconName="mailing"
      [isExpanded]="sectionsExpanded.mailingAddresses"
      (toggled)="toggleSection('mailingAddresses')"
    >
      <app-address-edit
        type="MAILING"
        [addresses]="businessAccountAddresses.mailingAddresses"
        (changed)="setAddresses($event, 'mailingAddresses')"
        (isFormInvalid)="addressFormValidity['MAILING'] = $event"
      />
    </app-expandable-form-section>

    <div class="separator"></div>

    <app-expandable-form-section
      title="Shipping Address"
      titleIconName="shipping"
      [isExpanded]="sectionsExpanded.shippingAddresses"
      (toggled)="toggleSection('shippingAddresses')"
    >
      <app-address-edit
        type="SHIPPING"
        [addresses]="businessAccountAddresses.shippingAddresses"
        (changed)="setAddresses($event, 'shippingAddresses')"
        (isFormInvalid)="addressFormValidity['SHIPPING'] = $event"
      />
    </app-expandable-form-section>
  </div>

  @if (submitError) {
    <div class="error-container">
      <div class="separator"></div>
      <div class="details-page-edit-form-error">{{ submitError }}</div>
    </div>
  }

  <div class="footer">
    <div class="separator"></div>

    <div class="buttons">
      <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
      <button rktButton type="submit" (click)="onSave()" [disabled]="isLoading || editForm.invalid || isSomeAddressFormInvalid">
        Save
      </button>
    </div>
  </div>
</div>
